export default function GetAmotMedaCat({ amotMedaCat, catIndex }) {
  const searchCat = amotMedaCat.find((amaCat) => amaCat.id == catIndex);
  return searchCat ? searchCat.title : "קטגוריה לא מוגדרת";
}
